const initialState = () => ({
  averageRetry: {},
  exerciseCefrDistribution: [],
  exerciseCounts: [],
  exerciseLogs: [],
  learnedBadges: [],
  learningStats: {},
  reactionTime: {},
  selectedExerciseLogTypeAndSkill: { exerciseType: 0, exerciseSkill: 0 },
  trophies: [],
  wordsPerMinute: {},
  recentExercises: [],
  loading: false
});

const historyState = initialState();

export { historyState };
